import {
  type ComponentType,
  type ReactNode,
  createContext,
  useContext,
} from 'react';

import type { RecordingsCodeBlockProps } from './RecordingsCodeBlock';

const RecordingsCodeBlockContext = createContext<
  ComponentType<RecordingsCodeBlockProps> | undefined
>(undefined);

export const RecordingsCodeBlockProvider = ({
  component,
  children,
}: {
  component: ComponentType<RecordingsCodeBlockProps>;
  children: ReactNode;
}) => (
  <RecordingsCodeBlockContext.Provider value={component}>
    {children}
  </RecordingsCodeBlockContext.Provider>
);

export const useRecordingsCodeBlockComponent = ():
  | ComponentType<RecordingsCodeBlockProps>
  | undefined => useContext(RecordingsCodeBlockContext);
